export default __webpack_public_path__ + "static/media/CodeIllustration.ecb185aa.svg";